import React, { useEffect, useCallback } from "react";
import { useLocation, useHistory } from "react-router-dom";
import HomeHeroSection from "component/HomeHeroSection";
import HomeInfoSection from "component/HomeInfoSection";
import Explore from "assets/find_the_right_school.png";
import GetPro from "assets/get_professional_2.png";
import ConnectStudents from "assets/connect_students.png";
import MakeItHappen from "component/MakeItHappen";
import SearchIcon from "assets/searchIcon.js";
import ListIcon from "assets/listIcon.js";
import TickIcon from "assets/tick.js";
import PartnerSchools from "component/PartnerSchools";
import PartnerWithUs from "component/PartnerWithUs";
import Testimonials from "component/Testimonials";
import FooterBox from "component/FooterBox";
import COLORS from "styles/colors";

function Index() {
  const handleFindPrograms = () => {
    window.open("https://app.schooliply.com/#/guest/find-programs", "_blank");
  };
  const makeItHappen = [
    {
      step: "STEP 1",
      value: "Find a match",
      icon: <SearchIcon />,
      bg: "#f0f8ff",
      desc: "Our AI technology matches you to open programs based on your profile and level of education. You can also search our database for institutions and programs by using a variety of filters including but not limited to country, educational level, tuition budget, etc."
    },
    {
      step: "STEP 2",
      value: "Apply to a Program",
      icon: <ListIcon />,
      bg: "#f0f8ff",
      desc: "Upload the required documents and apply for programs."
    },
    {
      step: "STEP 3",
      value: "Get Admission",
      icon: <TickIcon />,
      bg: "#f0f8ff",
      desc: "Schooliply reviews and verifies your document and applications and in turn, they are directly submitted to our partner schools. Your admission is granted upon being eligible."
    },
    {
      step: "STEP 4",
      value: "Visa Application",
      icon: <ListIcon />,
      bg: "#f0f8ff",
      desc: "Using our proprietary immigration tech platform, connect to a licensed immigration consultant in seconds to begin your study visa application process."
    }
  ];

  const partnerWithUsCard = [
    {
      header_tip: "FOR SCHOOLS",
      header:
        "Increase and meet your international student quota with qualified students from all over the globe.",
      desc: "With access to international student ambassadors, scouts, and international students from all over the world, Schooliply helps to increase your international student quota. Eliminate your marketing and seminar budgets and let us do the heavy lifting on your behalf.",
      btnText: "Learn More",
      more_link: "/schools"
    },
    {
      header_tip: "FOR SCOUTS",
      header:
        "Increase your study abroad clients’ admission chances by connecting to more schools in Canada, the US, the UK, Australia, etc. while earning commissions.",
      desc: "With access to schools in Canada, Australia, the UK, and the US, you can help your study abroad clients achieve their dreams of studying abroad while earning commission from Schooliply.",
      btnText: "Learn More",
      more_link:"/scouts"
    }
  ];

  const location = useLocation();
  const history = useHistory();
  const { pathname } = location;
  const RequestPartClick = () => {
    history.push({
      pathname: `/contact_us`
    });
  };
  const requestPartnership = {
    text: "Request Partnership",
    onClick: RequestPartClick
  };

  function isHidden(el) {
    var style = window.getComputedStyle(el);
    return style.display === "none" || style.visibility === "hidden";
  }

  const scrollToHowItWorks = useCallback(() => {
    let elems = document.querySelectorAll("[data-id='how-it-works']");
    if (elems.length > 0) {
      for (var i = 0, max = elems.length; i < max; i++) {
        if (!isHidden(elems[i])) {
          // visible
          let elem = elems[i];
          if (elem) {
            //elem.scrollIntoView({behavior: "smooth", block: "end"});
            let offsetTop = elem.offsetTop;
            /*if(window.innerWidth < 768){
              offsetTop += 600;
            }else{
              offsetTop += 50;
            }*/
            window.scroll({
              top: offsetTop,
              behavior: "smooth"
            });
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    if (location.pathname === "/" && location.hash === "#how-it-works") {
      scrollToHowItWorks();
    }
  }, [location, pathname, scrollToHowItWorks]);

  return (
    <>
      <HomeHeroSection
        bg="#5A189A"
        title="Ease your Search for Quality Education"
        desc="Make your educational goals a reality. Find schools & programs, gain admission, apply for visas and tie the knot with the best place for you. Take the hassle out of applying to any secondary and post-secondary institution anywhere in the world, by using Schooliply."
        btnText="Find Programs"
        onClick={handleFindPrograms}
        addEllipse={true}
      />
      <HomeInfoSection
        header_tip="FOR STUDENTS"
        header="Explore opportunities, Study abroad."
        desc="Make your educational goals a reality. Find schools & programs, gain admission, apply for visas to the US, UK, Canada, Australia, and many more countries."
        btnText="Learn More"
        img={Explore}
        imgStart={false}
        bg="#FBF8FF"
        btnLink="/students"
      />
      <HomeInfoSection
        header_tip="FOR STUDENTS"
        header="Get professional assistance in processing admission."
        desc="Make your educational goals a reality. Equipped with experienced admission consultants, Schooliply reviews your admission applications ensuring they meet institution requirements in order to increase your admission chances."
        btnText="Learn More"
        img={GetPro}
        imgStart={true}
        btnLink="/students"
      />
      <MakeItHappen
        header="MAKE IT HAPPEN"
        title="How Schooliply Works"
        bg="#F8FDFF"
        cardDetails={makeItHappen}
        id="how-it-works"
      />
      <PartnerSchools
        header="OUR PARTNER SCHOOLS"
        title="Find your perfect school"
        btnText="See All Institutions"
        showEllipse={true}
        desc="Make your educational goals a reality. Find schools & programs, gain admission, apply for visas and tie the knot with the best place for you. Take the hassle out of applying to any secondary and post-secondary institution anywhere in the world, by leveraging our proprietary study abroad platform Schooliply."
      />
      <PartnerWithUs
        title_tip="PARTNER WITH US"
        title="We make the best team"
        cardDetails={partnerWithUsCard}
        bg={COLORS.primaryBackground}
        fontColor={COLORS.white}
      />
      <HomeInfoSection
        header_tip="JOIN THE COMMUNITY"
        header="Connect with students, just like you."
        desc="The Schooliply community is a forum for current and prospective international students looking to study abroad. You can connect with students from around the world to share resources, learn from a variety of experiences to help inform better decisions."
        btnText="Learn More"
        img={ConnectStudents}
        imgStart={false}
        bg="#FFFCF8"
        btnLink="/community"
      />

      <Testimonials
        fontColor={COLORS.white}
        title_tip="TRUSTED BY MANY"
        title="Word from our students"
        bg={COLORS.primaryBackground}
      />
      <FooterBox
        header="Apply to your dream schools, for free."
        text="Make your educational goals a reality. Find schools & programs, gain admission, apply for visas and tie the knot with the best place for you. Take the hassle out of applying to any secondary and post-secondary institution anywhere in the world, by using Schooliply."
        btns={[requestPartnership]}
      />
    </>
  );
}

export default Index;
